import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../pages/Navbar";
import Footer from "../components/Footer";
import Chatbot from "../components/Chatbot";

import "../styles/AboutPage.css";

export default function AboutPage() {
  const { t } = useTranslation();

  const bust = useMemo(() => Date.now(), []);
  const [i, setI] = useState(0);

  const heroCandidates = [
    `https://source.unsplash.com/1200x800/?health,care&sig=${bust}`,
    `https://picsum.photos/seed/${bust}/1200/800`,
    `https://placehold.co/1200x800?text=Stay+Healthy`,
  ];

  // 🔼 Ensure page scrolls to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main className="about">
        <div className="about-grid">
          {/* LEFT: caring image */}
          <section className="about-left fade-in">
            <img
              src={heroCandidates[i]}
              alt={t("about.image_alt")}
              onError={() =>
                setI((n) => Math.min(n + 1, heroCandidates.length - 1))
              }
            />
          </section>

          {/* RIGHT: two stacked cards */}
          <section className="about-right">
            <div className="card motto-card">
              <h2>{t("about.motto_title")}</h2>
              <p>{t("about.motto_tagline")}</p>
            </div>

            <div className="card mission-card">
              <h3>{t("about.health_wealth_title")}</h3>
              <p>{t("about.paragraph")}</p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}